<template>
    <div class="main_container">
        <div class="view_title">{{$t('title_game_list_view')}}</div>

        <button @click="newGame" class="btn_new_game">
            {{$t('btn_game_list_new_game')}}
        </button>

        <div v-if="gameList.length == 0" class="no_play">진행한 게임이 없습니다.</div>
        <div class="game_list_item" v-for="(game, index) in gameList.slice().reverse()" :key="game.start_time">
            <span class="player_name">
                플레이어: [{{game.player_name}}]
            </span>
            <span class="score">
                점수: {{game.score}}점
            </span>
            <span class="start_time">
                {{dateToString(game.start_time)}}
            </span>
            <div style="margin-top: 10px;">
                <span class="resume_play" @click="resumePlay(index)">이어하기</span> 
                <span class="delete" @click="deleteItem(gameList.length - 1 - index)">삭제</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GameListView',
    data() {
        return {
            gameList: []
        }
    },
    mounted() {
        let games = this.$get('games')
        if(games == null) {
            this.$set('games', [])
            this.gameList = []
        }
        else {
            this.gameList = games
        }
    },
    methods: {
        newGame: function() {
            this.gameList.push(
                {
                    'start_time': Date.now(),
                    'num_of_factcheck': 0,
                    'author_try': 0,
                    'ref_try': 0,
                    'time_try': 0,
                    'logic_try': 0,
                    'author_correct': 0,
                    'ref_correct': 0,
                    'time_correct': 0,
                    'logic_correct': 0,
                    'player_name': null,
                    'complete_articles': 0,
                    'score': 0,
                    'selectedSection': 0
                }
            )
            this.$set('games', this.gameList)

            // 게임 데이터 초기화
            this.$loadGameData()
            this.$setCurrentPlayIndex(this.gameList.length - 1)
            this.$router.push('/inputPlayers')
        },
        dateToString: function(millis) {
            let time = new Date(millis)
            return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate() +
                ' ' + time.getHours() + ':' + time.getMinutes()
        },
        deleteItem: function(index) {
            this.gameList.splice(index, 1)
            this.$set('games', this.gameList)
        },

        resumePlay: function(index) {
            // console.log(index)
            this.$loadGameData()
            this.$setCurrentPlayIndex(this.gameList.length - 1 - index)
            this.$router.push('/sectionList')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* pc */
@media screen and (min-width: 415px) {
    .game_list_item {
        margin: 10px 80px;
        border: black solid 2px;
        padding: 10px;
    }
    .player_name {
        font-size: 30px;
        margin: 0px 20px;
        font-weight: 700;
    }
    .score {
        color: blue;
        margin: 0px 20px;
        font-size: 20px;
    }
    .start_time {
        color: gray;
        margin: 0px 20px;
        font-size: 20px;
    }
    .delete {
        border-radius: 10px;
        border: black solid 2px;
        padding: 5px 15px;
        background-color: black;
        color:white;
        cursor:pointer;
    }
    .resume_play {
        border-radius: 10px;
        border: black solid 2px;
        padding: 5px 15px;
        background-color: white;
        color:black;
        margin-right: 10px;
        cursor:pointer;
    }
    .no_play {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
    }
    .btn_new_game {
        margin: 40px 80px;
        font-size: 30px;
        width: 300px;
        border: 2px solid black;
        box-shadow: 2px 2px 2px gray;
        background-color: white;
        padding: 8px;
    }
}
/* mobile */
@media screen and (max-width: 414px) {
    .btn_new_game {
        position: fixed;
        left: calc(50vw - (260px / 2));
        bottom: 10%;
        font-size: 20px;
        width: 260px;
        border: 2px solid black;
        box-shadow: 2px 2px 2px gray;
        background-color: white;
        padding: 8px;
    }
    .game_list_item {
        margin: 10px 10px;
        border: black solid 2px;
        padding: 10px;
    }
    .player_name {
        font-size: 20px;
        margin: 0px 10px;
        font-weight: 700;
    }
    .score {
        color: blue;
        margin: 0px 10px;
        font-size: 18px;
    }
    .start_time {
        color: gray;
        margin: 0px 10px;
        font-size: 18px;
    }
    .no_play {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
    }
    .delete {
        border-radius: 10px;
        border: black solid 2px;
        padding: 5px 15px;
        background-color: black;
        color:white;
    }
    .resume_play {
        border-radius: 10px;
        border: black solid 2px;
        padding: 5px 15px;
        background-color: white;
        color:black;
        margin-right: 10px;
    }

}

</style>
